export const DATA_TYPE = {
	ActualGrowth: "ActualGrowth",
	Appetite: "Appetite",
	Biomass: "Biomass",
	Dose: "Dose",
	ExpectedGrowth: "ExpectedGrowth",
	FCR: "FCR",
	FeedAmount: "FeedAmount",
	FishCount: "FishCount",
	FishWeight: "FishWeight",
	Intensity: "Intensity",
	PelletFishMinute: "PelletFishMinute",
	Planned: "Planned",
	Recommended: "Recommended",
	SFR: "SFR",
	SGR: "SGR",
	Target: "Target",
	TodayAppetite: "TodayAppetite",
	TotalFeedWeight: "TotalFeedWeight",
	avgWeight: "avgWeight",
	blowerSpeed: "blowerSpeed",
	cleanerFishCount: "cleanerFishCount",
	conductivity: "conductivity",
	fcr: "fcr",
	feedStoreAmount: "feedStoreAmount",
	fishCount: "fishCount",
	humidity: "humidity",
	pressurePipe: "pressurePipe",
	recommendedFeedWeight: "recommendedFeedWeight",
	runtime: "runtime",
	sgr: "sgr",
	smartSpreaderCycleTime: "smartSpreaderCycleTime",
	smartSpreaderCyclicMax: "smartSpreaderCyclicMax",
	smartSpreaderCyclicMin: "smartSpreaderCyclicMin",
	smartSpreaderManualSpeed: "smartSpreaderManualSpeed",
	targetRecommended: "targetRecommended",
	temperatureFeedingLine: "temperatureFeedingLine",
	battery_remaining: "battery_remaining",
	cam_house_abs_hum: "cam_house_abs_hum",
	cam_house_img_temp: "cam_house_img_temp",
	cam_house_leakage: "cam_house_leakage",
	cam_house_pressure: "cam_house_pressure",
	cam_house_rel_hum: "cam_house_rel_hum",
	cam_house_temp: "cam_house_temp",
	cam_orien_x: "cam_orien_x",
	cam_orien_y: "cam_orien_y",
	cam_orien_z: "cam_orien_z",
	cam_tilt: "cam_tilt",
	low_oxygen_per_temperature_alert_level: "low_oxygen_per_temperature_alert_level",
	motor_house_abs_hum: "motor_house_abs_hum",
	motor_house_leakage: "motor_house_leakage",
	motor_house_pressure: "motor_house_pressure",
	motor_house_rel_hum: "motor_house_rel_hum",
	motor_house_temp: "motor_house_temp",
	oxy_serial_number: "oxy_serial_number",
	pellet_count: "pellet_count",
	power: "power",
	pressure: "pressure",
	sc_sp_standard: "sc_sp_standard",
	sea_current_absolute_speed: "sea_current_absolute_speed",
	sea_current_direction: "sea_current_direction",
	sea_current_east: "sea_current_east",
	sea_current_north: "sea_current_north",
	sensor_depth: "sensor_depth",
	tilt: "tilt",
	water_oxygen: "water_oxygen",
	water_salinity: "water_salinity",
	water_temperature: "water_temperature",
	wind_direction: "wind_direction",
	wind_speed: "wind_speed",
} as const;

export const MEASUREMENT_UNIT = {
	"%": "%",
	kg: "kg",
	g: "g",
	"g/s": "g/s",
	g_per_s: "g_per_s",
	Tonne: "Tonne",
	pellet: "pellet",
	PFM: "PFM",
	Hz: "Hz",
	"°": "°",
	"mS/cm": "mS/cm",
	pellets: "pellets",
	"n/m3": "n/m3",
	Bar: "Bar",
	seconds: "seconds",
	"ms/cm": "ms/cm",
	"km/m3": "km/m3",
	"m/s": "m/s",
	"°C": "°C",
	"°/M": "°/M",
	"cm/s": "cm/s",
	dB: "dB",
	"°M": "°M",
	"Deg.M": "Deg.M",
	m: "m",
	Sec: "Sec",
	RPM: "RPM",
	"mg/L": "mg/L",
	"Mg/l": "Mg/l",
	umol: "umol",
	"μmol/l": "μmol/l",
	"umol/l": "umol/l",
	psu: "psu",
	ppt: "ppt",
	PSU: "PSU",
} as const;

export const DEPTH_SELECTION_OPTION = {
	option1: {
		id: "0-5m",
		min: 0,
		max: 5,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
	option2: {
		id: "5-10m",
		min: 5,
		max: 10,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
	option3: {
		id: "10-15m",
		min: 10,
		max: 15,
		measurementUnit: MEASUREMENT_UNIT.m,
	},
};

export const DATA_TYPE_MEASUREMENT_UNIT_MAP = {
	[DATA_TYPE.ActualGrowth]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.Appetite]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.Biomass]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Dose]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.ExpectedGrowth]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.FCR]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.FeedAmount]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.FishWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.Intensity]: [MEASUREMENT_UNIT["g/s"], MEASUREMENT_UNIT.g_per_s],
	[DATA_TYPE.PelletFishMinute]: [MEASUREMENT_UNIT.PFM],
	[DATA_TYPE.Planned]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.Recommended]: [MEASUREMENT_UNIT.kg],
	[DATA_TYPE.SFR]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.SGR]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.Target]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.TodayAppetite]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.TotalFeedWeight]: [MEASUREMENT_UNIT.kg, MEASUREMENT_UNIT.g],
	[DATA_TYPE.avgWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.blowerSpeed]: [MEASUREMENT_UNIT.Hz],
	[DATA_TYPE.conductivity]: [MEASUREMENT_UNIT["mS/cm"]],
	[DATA_TYPE.fcr]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.feedStoreAmount]: [MEASUREMENT_UNIT.g, MEASUREMENT_UNIT.kg],
	[DATA_TYPE.humidity]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.pellet_count]: [MEASUREMENT_UNIT.pellets],
	[DATA_TYPE.pressure]: [MEASUREMENT_UNIT["n/m3"]],
	[DATA_TYPE.pressurePipe]: [MEASUREMENT_UNIT.Bar],
	[DATA_TYPE.recommendedFeedWeight]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.runtime]: [MEASUREMENT_UNIT.seconds],
	[DATA_TYPE.sgr]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.smartSpreaderCycleTime]: [MEASUREMENT_UNIT.Sec],
	[DATA_TYPE.smartSpreaderCyclicMax]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.smartSpreaderCyclicMin]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.smartSpreaderManualSpeed]: [MEASUREMENT_UNIT.RPM],
	[DATA_TYPE.targetRecommended]: [MEASUREMENT_UNIT.g],
	[DATA_TYPE.temperatureFeedingLine]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.battery_remaining]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.cam_house_abs_hum]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.cam_house_img_temp]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.cam_house_pressure]: [MEASUREMENT_UNIT.Bar],
	[DATA_TYPE.cam_house_rel_hum]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.cam_house_temp]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.cam_orien_x]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.cam_orien_y]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.cam_orien_z]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.cam_tilt]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.motor_house_abs_hum]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.motor_house_pressure]: [MEASUREMENT_UNIT.Bar],
	[DATA_TYPE.motor_house_rel_hum]: [MEASUREMENT_UNIT["%"]],
	[DATA_TYPE.motor_house_temp]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.sc_sp_standard]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sea_current_absolute_speed]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sea_current_direction]: [
		MEASUREMENT_UNIT["°M"],
		MEASUREMENT_UNIT["°/M"],
		MEASUREMENT_UNIT["Deg.M"],
	],
	[DATA_TYPE.sea_current_east]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sea_current_north]: [MEASUREMENT_UNIT["cm/s"]],
	[DATA_TYPE.sensor_depth]: [MEASUREMENT_UNIT.m],
	[DATA_TYPE.tilt]: [MEASUREMENT_UNIT["°"]],
	[DATA_TYPE.water_oxygen]: [
		MEASUREMENT_UNIT["%"],
		MEASUREMENT_UNIT["mg/L"],
		MEASUREMENT_UNIT["Mg/l"],
		MEASUREMENT_UNIT.umol,
		MEASUREMENT_UNIT["μmol/l"],
		MEASUREMENT_UNIT["umol/l"],
	],
	[DATA_TYPE.water_salinity]: [MEASUREMENT_UNIT.psu, MEASUREMENT_UNIT.ppt, MEASUREMENT_UNIT.PSU],
	[DATA_TYPE.water_temperature]: [MEASUREMENT_UNIT["°C"]],
	[DATA_TYPE.wind_direction]: [MEASUREMENT_UNIT["Deg.M"]],
	[DATA_TYPE.wind_speed]: [MEASUREMENT_UNIT["cm/s"]],
} as const;

export const DATE_FORMAT = {
	DATE_TIME: "FORMAT:date.date_time",
	DATE_HOURS: "FORMAT:date.date_hours",
	WEEKDAY_DATE_SHORT_MONTH_YEAR: "FORMAT:date.weekday_date_short_month_year",
	DATE: "FORMAT:date.date",
	TIME: "FORMAT:date.time",
	DAY_MONTH: "FORMAT:date.day_month",
} as const;

export const DURATION_FORMAT = {
	HOURS_MINUTES: "FORMAT:duration-fmt.hours-minutes",
	HOURS_MINUTES_SECONDS: "FORMAT:duration-fmt.hours-minutes-seconds",
	DAYS_HOURS_MINUTES_SECONDS: "FORMAT:duration-fmt.days-hours-minutes-seconds",
	DAYS_HOURS_MINUTES: "FORMAT:duration-fmt.days-hours-minutes",
	HOURS: "FORMAT:duration-fmt.hours",
} as const;

export const UNIT_FORMAT = {
	GRAM: "FORMAT:unit.g",
	KILOGRAM: "FORMAT:unit.kg",
	TONS: "FORMAT:unit.tn",
	PERCENT: "FORMAT:unit.percent",
	KILOGRAM_PER_MINUTE: "FORMAT:unit.kg/m",
	AS_GRAM: "FORMAT:unit.as_g",
	TEMPERATURE: "FORMAT:unit.temperature",
	PSU: "FORMAT:unit.PSU",
	LENGTH: "FORMAT:unit.length",
	UNITLESS: "FORMAT:unit.noUnit",
	UMOL: "FORMAT:unit.umol",
	MG_L: "FORMAT:unit.mg/l",
	M_S: "FORMAT:unit.m/s",
	RPM: "FORMAT:unit.rpm",
	HZ: "FORMAT:unit.hz",
	BAR: "FORMAT:unit.bar",
	SECONDS: "FORMAT:unit.seconds",
	DEGREES: "FORMAT:unit.degrees",
	CM_S: "FORMAT:unit.cm/s",
	KM_M3: "FORMAT:unit.km/m3",
	N_M3: "FORMAT:unit.n/m3",
	PFM: "FORMAT:unit.pfm",
	PELLETS: "FORMAT:unit.pellets",
} as const;

export const MEASUREMENT_UNITS = Object.values(MEASUREMENT_UNIT);
export const DATA_TYPES = Object.values(DATA_TYPE);
export const DEPTH_SELECTION_OPTIONS = Object.values(DEPTH_SELECTION_OPTION);
